import React, { Component } from 'react';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import AccountServices from '../../services/axioServices/apiServices/AccountServices.js';
import moment from 'moment';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import FirstPageGSTPurchaseEntryForStockCredit from '../../components/account/StockCreditEntry/FirstPageGSTPurchaseEntryForStockCredit.js';
import ItemForm1ForStockCredit from '../../components/account/StockCreditEntry/ItemForm1ForStockCredit.js';
import ItemTableForStockCredit from '../../components/account/StockCreditEntry/ItemTableForStockCredit.js';
import HSNCodeTableFormForStockCredit from '../../components/account/StockCreditEntry/HSNCodeTableFormForStockCredit.js';
import PaymentSummaryForStockCredit from '../../components/account/StockCreditEntry/PaymentSummaryForStockCredit.js';
import ItemForm2ForStockCredit from '../../components/account/StockCreditEntry/ItemForm2ForStockCredit.js';
import ItemDetailsModelForStockCredit from '../../components/account/StockCreditEntry/ItemDetailsModelForStockCredit.js';

class StockCreditEntry extends Component {
    constructor(props) {
        super(props);
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.accountServices = new AccountServices();
        this.state = {
            index: null,
            isGridView: true,
            isEditing: false,
            noItemFound: "",
            setItemDetailsModel: false,
            validationTextForGRNEntry: '',
            pendingGRNPurchaseEntryList: [],
            gstPurchaseEntryRMPMList: [],
            filterDetails: {
                partyName: "",
                arrangedBy: "srNo",
            },
            invoiceDetails: {
                gstPurchaseEntryRMPMId: "",
                srNo: "",
                invoiceNo: "",
                invoiceDate: "",
                purchaseEntryNo: "",
                partyId: "",
                partyName: "",
                freight: "",
                other: "",
                roundOff: "",
                subTotal: "",
                sgst: "",
                cgst: "",
                igst: "",
                ugst: "",
                grandTotal: "",
                remarks: "",
                pendingAmount: "",
                invoiceType: "",
                isPurchaseEntry: false,
            },
            itemDetails: {
                grnPartyDetailsId: '',
                grnMaterialId: '',
                grnNo: '',
                other: '',
                rawMaterialId: '',
                packageMaterialId: '',
                itemId: '',
                itemName: '',
                batchNo: '',
                expDate: '',
                mrp: '',
                rpRate: '',
                mfgr: '',
                qty: 0,
                free: 0,
                rate: 0,
                amount: 0,
                hsnCodeId: '',
                hsnCodeName: '',
                sgst: 0,
                cgst: 0,
                igst: 0,
                ugst: 0,
                taxableAmount: 0,
                sgstAmount: 0,
                cgstAmount: 0,
                ugstAmount: 0,
                igstAmount: 0,
            },
            partyDropdownList: [],
            itemListing: [],
            rawMaterialList: [],
            packingMaterialDropDownList: [],
            hsnCodeList: [],
            hsnCodeListForTable: [],
            arrangedByList: [
                { arrangedBy: "Ser. No.", value: "srNo" },
                { arrangedBy: "Invoice No.", value: "invoiceNo" },
                { arrangedBy: "Invoice Date", value: "invoiceDate" },
                { arrangedBy: "Party Name", value: "partyName" },
                { arrangedBy: "Net Amount", value: "grandTotal" },
            ],
            invoiceTypeList: [
                { invoiceType: "Tax Invoice", value: "taxInvoice" },
                { invoiceType: "Other Credit", value: "otherCredit" },
            ],
            validationRules: {
                partyId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "party name"
                        ),
                    },
                ],
                invoiceNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "invoice No"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForItemDetails: {
                itemId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "item name"
                        ),
                    },
                ],
                hsnCodeName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "hsn Code"
                        ),
                    },
                ],
            },
            validStateForItemDetails: {
                isValid: true,
                error: {},
            },

        };
    };


    componentDidMount() {
        this.getAllPartyDropdown()
    }

    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                    email: item.email,
                }));
                this.setState({ partyDropdownList: dropdownItems }, () => {
                    this.getAllHSNCode()
                });
            } else {
                this.getAllHSNCode()
                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    getAllHSNCode = () => {
        this.commonServices.getAllHSNCode().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.HSNCode,
                    value: item._id,
                    sgstRate: item.SGST,
                    cgstRate: item.CGST,
                    igstRate: item.IGST,
                    utgstRate: item.UTGST
                }));
                this.setState({ hsnCodeList: dropdownItems });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getGSTPurchseEntryInvoiceNo = () => {
        this.closeGridView()
    }

    closeGridView = () => {
        this.setState({ isGridView: false });
    };

    openGridView = () => {
        this.resetForm();
        this.setState({ isGridView: true, isEditing: false });
    };

    resetForm = () => {
        let validState = this.state.validState
        validState.error = {}
        validState.isValid = true
        let Fdetails = this.state.filterDetails;
        Fdetails.partyName = "";
        Fdetails.arrangedBy = "srNo";

        let Idetails = this.state.invoiceDetails;
        Idetails.gstPurchaseEntryRMPMId = "";
        Idetails.srNo = "";
        Idetails.invoiceNo = "";
        Idetails.invoiceDate = "";
        Idetails.purchaseEntryNo = "";
        Idetails.partyId = "";
        Idetails.freight = "";
        Idetails.other = "";
        Idetails.roundOff = "";
        Idetails.subTotal = "";
        Idetails.sgst = "";
        Idetails.cgst = "";
        Idetails.igst = ""
        Idetails.ugst = ""
        Idetails.grandTotal = ""
        Idetails.remarks = "";
        Idetails.pendingAmount = "";
        this.setState({
            invoiceDetails: Idetails, filterDetails: Fdetails, noItemFound: "", validState: validState, itemListing: [], hsnCodeListForTable: []
        }, () => {
            this.getAllGSTPurchaseEntryRMPM()
        }, () => {
            this.resetItemDetailsForm()
        });
    };

    resetItemDetailsForm = () => {
        let validStateForItemDetails = this.state.validStateForItemDetails
        validStateForItemDetails.isValid = true
        validStateForItemDetails.error = {}
        let details = this.state.itemDetails
        details.itemId = ''
        details.itemName = ''
        details.grnNo = ''
        details.batchNo = ''
        details.qty = 0
        details.rate = 0
        details.amount = 0
        details.taxableAmount = 0
        details.hsnCodeId = ''
        details.hsnCodeName = ''
        details.sgst = 0
        details.cgst = 0
        details.igst = 0
        details.ugst = 0
        details.sgstAmount = 0
        details.cgstAmount = 0
        details.igstAmount = 0
        details.ugstAmount = 0
        this.setState({ itemDetails: details, validStateForItemDetails: validStateForItemDetails })
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.invoiceDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    openPopUpForAddingItem = () => {
        this.setState({ setItemDetailsModel: true })
    };

    setOpenModel = () => {
        this.setState({ setItemDetailsModel: !this.state.setItemDetailsModel });
    };

    closePopUp = () => {
        this.setState({ setItemDetailsModel: false })
    }

    handleChange = (event, name, section) => {
        let value = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = value.toUpperCase();
            this.setState({ filterDetails: details }, () => {
                this.getAllGSTPurchaseEntryRMPM()
            });
        } else if (section === "invoiceDetails") {
            let details = this.state.invoiceDetails;
            details[name] = value.toUpperCase();
            if (name === 'freight' || name === 'other' || name === 'roundOff') {
                this.calculateGrandTotal()
            }
            this.setState({ invoiceDetails: details });
        }
    };

    handleDropDownChange = (event, name) => {
        const select = event.target.value;
        let details = this.state.filterDetails;
        details[name] = select;
        this.setState({ filterDetails: details }, () => {
            this.getAllGSTPurchaseEntryRMPM()
        });
    };

    handleDropDownChangeForFirstForm = (event, name) => {
        const select = event.target.value;
        let details = this.state.invoiceDetails;
        details[name] = select;
        this.setState({ invoiceDetails: details });
    };

    handleChangeForDatePicker = (date, name) => {
        let details = this.state.itemDetails;
        details[name] = date;
        this.setState({ itemDetails: details });
    }

    handleCheckbox = (event, name) => {
        const checked = event.target.checked;
        let details = this.state.invoiceDetails;
        details[name] = checked;
        this.setState({ invoiceDetails: details });
    }

    setFilterParameters = (selected, drpIdentity, section) => {
        let details = this.state.invoiceDetails;
        details[drpIdentity] = selected.value;
        if (drpIdentity === 'partyId') {
            details.partyName = selected.label
        }
        this.setState({ invoiceDetails: details });
    };

    setFilterParametersForItemTable = (selected, fieldName) => {
        let details = this.state.itemDetails;
        details[fieldName] = selected.value;
        if (fieldName === 'itemId') {
            details.packing = selected.packing
            details.itemName = selected.label
        }
        if (fieldName === 'hsnCodeId') {
            details.hsnCodeName = selected.label
            details.sgst = selected.sgstRate
            details.cgst = selected.cgstRate
            details.igst = selected.igstRate
            details.ugst = selected.utgstRate
        }
        this.setState({ itemDetails: details }, () => {
            this.calculateItemAmount()
        });
    };

    calculateItemAmount = () => {
        let itemDetails = this.state.itemDetails
        itemDetails.taxableAmount = Number(itemDetails.amount) + Number(itemDetails.other)
        itemDetails.sgstAmount = Number(itemDetails.sgst) * Number(itemDetails.taxableAmount) / 100
        itemDetails.cgstAmount = Number(itemDetails.cgst) * Number(itemDetails.taxableAmount) / 100
        itemDetails.igstAmount = Number(itemDetails.igst) * Number(itemDetails.taxableAmount) / 100
        itemDetails.ugstAmount = Number(itemDetails.ugst) * Number(itemDetails.taxableAmount) / 100
        this.setState({ itemDetails: itemDetails })
    }

    handleChangeForItemTable = (event, fieldName) => {
        let value = event.target.value
        let details = this.state.itemDetails;
        details[fieldName] = value;
        this.setState({ itemDetails: details }, () => {
            this.calculateItemAmount()
        });
    };

    getGSTPurchseEntrySRNo = () => {
        this.accountServices.getGSTPurchseEntrySRNo().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let details = this.state.invoiceDetails
                details.srNo = response.responseData.srNo
                details.invoiceDate = moment(new Date()).format('yyyy-MM-DD')
                this.setState({ contraDetails: details }, () => {
                    this.closeGridView()
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    selectPendingGRNEntry = (item) => {
        let details = this.state.itemDetails
        details.grnMaterialId = item._id
        details.grnPartyDetailsId = item.grnEntryPartyDetailId._id
        details.packageMaterialId = item.packageMaterialId ? item.packageMaterialId._id : null
        details.rawMaterialId = item.rawMaterialId ? item.rawMaterialId._id : null
        details.itemId = item.rawMaterialId ? item.rawMaterialId._id : item.packageMaterialId._id
        details.itemName = item.packageMaterialId ? item.packageMaterialId.pmName : item.rawMaterialId.rmName
        details.grnType = item.packageMaterialId ? 'Packing' : 'Raw'
        details.batchNo = item.batchNo
        details.qty = item.qty
        details.rate = item.rate
        details.amount = item.amount
        details.grnNo = item.grnEntryPartyDetailId.grnNo
        this.setState({ itemDetails: details }, () => {
            this.setState({ pendingGRNPurchaseEntryList: [] })
        })
    }

    updateGRNEntryToPurchaseEntry = (grnMaterialId, grnPartyDetailsId, isGRNEntryDone) => {
        let request = {
            grnMaterialId: grnMaterialId,
            grnPartyDetailsId: grnPartyDetailsId,
            isGRNEntryDone: isGRNEntryDone
        }
        this.accountServices.updateGRNEntryToPurchaseEntry(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                // GRN Entry Updated
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    isValidAllFieldsForItemDetails = () => {
        const newValidState = isValidForm(
            this.state.itemDetails,
            this.state.validationRulesForItemDetails,
            this.state.validStateForItemDetails
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };


    addItemToItemArray = () => {
        let isValidAllFieldsForItemDetails = this.isValidAllFieldsForItemDetails();
        if (isValidAllFieldsForItemDetails) {
            let itemListing = [...this.state.itemListing];
            let details = { ...this.state.itemDetails }
            if (this.state.index >= 0 && this.state.index !== null && this.state.index !== undefined) {
                itemListing[this.state.index] = details
            } else {
                itemListing.push(details);
            }
            this.setState({ itemListing: itemListing, setItemDetailsModel: false }, () => {
                this.updateGRNEntryToPurchaseEntry(this.state.itemDetails.grnMaterialId, this.state.itemDetails.grnPartyDetailsId, true)
                this.showHSNCodes()
            })
        }
    }

    showHSNCodes = () => {
        const { itemListing } = this.state;

        const filtered = itemListing.map(({ hsnCodeName, taxableAmount, sgst, sgstAmount, cgst, cgstAmount, igst, igstAmount, ugst, ugstAmount }) => ({
            hsnCodeName,
            taxableAmount,
            sgst,
            sgstAmount,
            cgst,
            cgstAmount,
            igst,
            igstAmount,
            ugst,
            ugstAmount
        }));

        this.setState({ hsnCodeListForTable: filtered }, () => {
            this.calculateGrandTotal()
        });
    }

    calculateGrandTotal = () => {
        let list = this.state.hsnCodeListForTable

        const totals = list.reduce(
            (acc, item) => {
                acc.sgstAmount += Number(item.sgstAmount) || 0;
                acc.cgstAmount += Number(item.cgstAmount) || 0;
                acc.igstAmount += Number(item.igstAmount) || 0;
                acc.utgstAmount += Number(item.utgstAmount) || 0;
                acc.taxableAmount += Number(item.taxableAmount) || 0;
                return acc;
            },
            { sgstAmount: 0, cgstAmount: 0, igstAmount: 0, utgstAmount: 0, taxableAmount: 0 }
        );

        let details = this.state.invoiceDetails
        details.subTotal = Number(totals.taxableAmount).toFixed(2)
        details.sgst = Number(totals.sgstAmount).toFixed(2)
        details.cgst = Number(totals.cgstAmount).toFixed(2)
        details.igst = Number(totals.igstAmount).toFixed(2)
        details.ugst = Number(totals.utgstAmount).toFixed(2)
        details.grandTotal = (Number(details.subTotal) + Number(details.sgst) + Number(details.igst) + Number(details.cgst)).toFixed(2)
        details.grandTotal = Number(details.grandTotal) + (Number(details.freight) || 0) + (Number(details.other) || 0)
        details.roundOff = (details.grandTotal % 1).toFixed(2);
        details.grandTotal = Math.floor(details.grandTotal);
        details.pendingAmount = Math.floor(details.grandTotal)
        this.setState({ invoiceDetails: details })
    }

    deleteItemById = (index) => {
        let list = [...this.state.itemListing];
        list.splice(index, 1);
        this.setState({ itemListing: list }, () => {
            this.updateGRNEntryToPurchaseEntry(this.state.itemDetails.grnMaterialId, this.state.itemDetails.grnEntryPartyDetailId, false)
            this.showHSNCodes()
        });
    }

    addEditGSTPurchaseEntryRMPM = () => {
        let isValidAllFields = this.isValidAllFields()
        if (isValidAllFields) {
            if (this.state.itemListing.length > 0) {
                let request = {
                    invoiceDetails: this.state.invoiceDetails,
                    itemListing: this.state.itemListing
                }
                this.accountServices.addEditGSTPurchaseEntryRMPM(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        let details = this.state.invoiceDetails
                        details.gstPurchaseEntryRMPMId = response.responseData.invoiceDetails._id
                        this.setState({ invoiceDetails: details })
                        this.SwalServices.Success(response.Message)
                        this.openGridView()
                    } else {
                        this.SwalServices.Error(response.Message);
                        this.openGridView()
                    }
                });

            } else {
                this.SwalServices.Alert('No records found. Please add item to proceed.')
            }
        }
    }

    getGSTPurchaseEntryRMPMById = (id,) => {
        this.accountServices.getGSTPurchaseEntryRMPMById(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData
                let details = this.state.invoiceDetails
                details.srNo = res.invoiceDetails.srNo
                details.gstPurchaseEntryRMPMId = res.invoiceDetails._id
                details.invoiceNo = res.invoiceDetails.invoiceNo
                details.invoiceDate = moment(res.invoiceDetails.invoiceDate).format('yyyy-MM-DD')
                details.purchaseEntryNo = res.invoiceDetails.purchaseEntryNo
                details.partyId = res.invoiceDetails.partyId._id
                details.partyName = res.invoiceDetails.partyId.partyName
                details.freight = res.invoiceDetails.freight
                details.other = res.invoiceDetails.other
                details.roundOff = res.invoiceDetails.roundOff
                details.subTotal = res.invoiceDetails.subTotal
                details.sgst = res.invoiceDetails.sgst
                details.cgst = res.invoiceDetails.cgst
                details.igst = res.invoiceDetails.igst
                details.ugst = res.invoiceDetails.ugst
                details.grandTotal = res.invoiceDetails.grandTotal
                details.pendingAmount = res.invoiceDetails.pendingAmount

                let list = res.itemListing
                list.map(item => {
                    item.isFromDB = true
                    return item
                })
                this.setState({ invoiceDetails: details, itemListing: list }, () => {
                    this.showHSNCodes()
                    this.setState({ isGridView: false })
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    deleteGSTPurchaseEntryRMPMById = (id) => {
        this.SwalServices.Confirm(
            "",
            ``,
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text,
            `Are you sure you want to delete this Purchase Entry?`
        ).then((response) => {
            if (response === true) {
                this.accountServices.deleteGSTPurchaseEntryRMPMById(id).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        this.getAllGSTPurchaseEntryRMPM()
                        this.SwalServices.Success(response.Message);
                    } else {
                        this.SwalServices.Error(response.Message);
                    }
                });
            }
        });
    }

    render() {
        return (
            <>
                <div className='firstPageGSTPurchaseEntry-page'>
                    {/* First page  */}
                    {this.state.isGridView === true ? (
                        <FirstPageGSTPurchaseEntryForStockCredit
                            filterDetails={this.state.filterDetails}
                            handleChange={this.handleChange.bind(this)}
                            arrangedByList={this.state.arrangedByList}
                            handleDropDownChange={this.handleDropDownChange.bind(this)}
                            getGSTPurchseEntryInvoiceNo={this.getGSTPurchseEntryInvoiceNo.bind(this)}
                            getGSTPurchseEntrySRNo={this.getGSTPurchseEntrySRNo.bind(this)}
                            gstPurchaseEntryRMPMList={this.state.gstPurchaseEntryRMPMList}
                            getGSTPurchaseEntryRMPMById={this.getGSTPurchaseEntryRMPMById.bind(this)}
                            deleteGSTPurchaseEntryRMPMById={this.deleteGSTPurchaseEntryRMPMById.bind(this)}
                            noItemFound={this.state.noItemFound}
                        />
                    ) : null}

                    {this.state.isGridView === false ? (
                        <div>
                            {/* 1. Item Form  */}
                            <ItemForm1ForStockCredit
                                invoiceDetails={this.state.invoiceDetails}
                                handleChange={this.handleChange.bind(this)}
                                validState={this.state.validState}
                                partyDropdownList={this.state.partyDropdownList}
                                setFilterParameters={this.setFilterParameters.bind(this)}
                                invoiceTypeList={this.state.invoiceTypeList}
                                handleDropDownChangeForFirstForm={this.handleDropDownChangeForFirstForm.bind(this)}
                                handleCheckbox={this.handleCheckbox.bind(this)}
                            />
                            {/* 2.  Item tabel  */}
                            <ItemTableForStockCredit
                                itemListing={this.state.itemListing}
                                openPopUpForAddingItem={this.openPopUpForAddingItem.bind(this)}
                                hsnCodeList={this.state.hsnCodeList}
                                deleteItemById={this.deleteItemById.bind(this)}
                            />
                            {/* 3. Table & Sections  */}
                            <div className="flex  gap-2.5 mb-4">
                                <HSNCodeTableFormForStockCredit
                                    hsnCodeListForTable={this.state.hsnCodeListForTable}
                                    invoiceDetails={this.state.invoiceDetails}
                                    handleChange={this.handleChange.bind(this)}
                                />
                                <PaymentSummaryForStockCredit
                                    invoiceDetails={this.state.invoiceDetails}
                                    handleChange={this.handleChange.bind(this)}

                                />
                            </div>
                            <hr />

                            {/*4. Item form   */}
                            <ItemForm2ForStockCredit
                                invoiceDetails={this.state.invoiceDetails}
                                handleChange={this.handleChange.bind(this)}
                            />
                            <div className="btn-grp flex gap-2.5 mt-4">
                                <button
                                    className="add-btn"
                                    onClick={() => this.addEditGSTPurchaseEntryRMPM()}
                                >
                                    Save
                                </button>
                                <button
                                    className="cancel-btn"
                                    onClick={() => this.openGridView()}
                                >
                                    Cancel
                                </button>
                            </div>

                        </div>
                    ) : null}
                </div>

                <ItemDetailsModelForStockCredit
                    setItemDetailsModel={this.state.setItemDetailsModel}
                    setOpenModel={this.setOpenModel.bind(this)}
                    hsnCodeList={this.state.hsnCodeList}
                    rawMaterialList={this.state.rawMaterialList}
                    packingMaterialDropDownList={this.state.packingMaterialDropDownList}
                    setFilterParametersForItemTable={this.setFilterParametersForItemTable.bind(this)}
                    handleChangeForItemTable={this.handleChangeForItemTable.bind(this)}
                    itemDetails={this.state.itemDetails}
                    validState={this.state.validState}
                    closePopUp={this.closePopUp.bind(this)}
                    isEditing={this.state.isEditing}
                    pendingGRNPurchaseEntryList={this.state.pendingGRNPurchaseEntryList}
                    selectPendingGRNEntry={this.selectPendingGRNEntry.bind(this)}
                    addItemToItemArray={this.addItemToItemArray.bind(this)}
                    validationTextForGRNEntry={this.state.validationTextForGRNEntry}
                    handleChangeForDatePicker={this.handleChangeForDatePicker.bind(this)}
                />
            </>
        );
    }
}

export default StockCreditEntry;